/**
 * Styled Components - Created by miguelcanobbio on 31/05/18.
 */
import styled from 'styled-components'
import Input from 'antd/lib/input'
import Button from 'antd/lib/button'
import Checkbox from 'antd/lib/checkbox'
import { WHITE_TRANSPARENT, GRAY_DARK, GRAY, BLUE, WHITE, GRAY_LIGHT } from '../../theme/colors'
import Icon from 'antd/lib/icon'

interface InputProps {
  inputhWidth?: string
}

interface RowProps {
  marginBottom?: string
}

interface DivProps {
  onlyDetails?: boolean
}

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: ${({ onlyDetails }: DivProps) => onlyDetails ? '0' : '32px'};
  margin-bottom: ${({ onlyDetails }: DivProps) => onlyDetails ? '0' : '-64px'};
  @media (min-width: 320px) and (max-width: 1024px) {
    padding: 24px 0;
  }
`

export const Title = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  margin-bottom: 24px;
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: ${({ marginBottom }: RowProps) =>
    marginBottom ? marginBottom : '16px'};
`

export const Column = styled.div`
  width: ${({ inputhWidth }: InputProps) =>
    inputhWidth ? inputhWidth : '400px'};
`

export const InputTitleContainer = styled.div`
  display: flex;
`
export const Label = styled.div`
  height: 19px;
  color: ${GRAY_DARK};
  font-size: 14px;
  letter-spacing: 0.18px;
  line-height: 19px;
`

export const StyledButton = styled(Button)`
  height: 40px;
  width: 100%;
  border-radius: 2px;
`

export const StyledInputGroup = styled(Input.Group)`
  height: 40px;
  border-radius: 0;
  display: flex;
  flex-direction: row;
  width: 100%;
`

export const StyledInputAmount = styled(Input)`
  height: 40px;
  border-radius: 0;
  width: 80%;
`

export const StyledInputUnity = styled(Input)`
  height: 40px;
  border-radius: 0;
  border-left: 0;
  pointer-events: none;
  background-color: #fff;
  width: 20%;
`

export const StyledCheckbox = styled(Checkbox)`
  height: 36px;
  color: ${GRAY_DARK};
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin: 5px 0;
`

export const DropDownPlaceHolder = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  width: 100%;
  border: 1px solid ${GRAY};
  border-radius: 0;
  margin-top: 5px;
  &:hover {
    border: 1px solid ${GRAY};
    color: ${GRAY};
  }
`

export const LoadingErrorContainer = styled.div`
  display: flex;
  flex: 1;
  height: 60vh;
  justify-content: center;
  align-items: center;
`

export const ErrorMessage = styled.div`
  margin-top: 16px;
  font-size: 16px;
  line-height: 23px;
  text-align: center;
`

export const LoadingContainer = styled.div`
  width: 100%;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 10000;
  height: 100vh;
  background: ${WHITE_TRANSPARENT};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const PayIcon = styled.img`
  max-width: 158px;
  width: 100%;
  margin-left: -16px;
  margin-bottom: 12px;
`

export const ModalTitle = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const InfoBody = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin: 12px 0 12px -38px;
`

export const CloseButton = styled(Icon)`
  font-size: 16px;
  position: absolute;
  right: 20px;
  top: 20px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const buttonStyle = {
  background: BLUE,
  color: WHITE,
  border: 'none',
  boxShadow: 'none'
}

export const cancelButtonStyle = {
  background: WHITE,
  color: GRAY_DARK,
  borderColor: GRAY_LIGHT,
  boxShadow: 'none'
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/AffiliateOptions/styledComponents.tsx